

























































































import { Component, Emit, Prop, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AuthStoreHelper, RootStoreHelper, StoreHelper } from '../../core/mixins';
import { EventBus, PRIVILEGE_KEYS, PRIVILEGE_TYPES, TypeEventBus } from '../../core/utils';
import Checkbox from '../../core/components/Checkbox.vue';

@Component({
    components: {
        Checkbox
    }
})
export default class Actions extends Mixins(RootStoreHelper, StoreHelper, AuthStoreHelper) {
    @Prop({ default: true }) disableEdit: boolean;
    @Prop({ default: true }) disableRemove: boolean;
    @Prop() tab: boolean;
    @Prop({ default: false }) disableAdd: boolean;
    @Prop({ default: '' }) hintAdd: string;
    @Prop({ default: '' }) hintRemove: string;
    @Prop({ default: '' }) hintEdit: string;
    @Prop({ default: '' }) hintFilters: string;
    geofenceSelected: string = '';
    menu: boolean = false;
    geofencesSelected: any = [];
    gfTypes: any = [];

    get canManipulateGeofencesOrPoints(): boolean{
        return this.$_checkPrivilegesEqual(PRIVILEGE_KEYS.ONLY_LAST_REPORT, PRIVILEGE_TYPES.NONE)
    }

    mounted() {
        EventBus.$on(TypeEventBus.FILTER_GEOFENCE_TABLE, () => {
            if (this.existGeofenceFilter) {
                this.$_setGeofencesType(this.getGeofenceType);
                this.$_setGeofencesFilter(this.getGeofenceType);
            }
        });
    }

    get existGeofenceFilter() {
        if (this.getGeofenceType.length == 0) {
            return false;
        } else {
            let gfFilter = JSON.parse(JSON.stringify(this.$_getGeofencesFilter));
            let checkedItems = gfFilter.filter(item => item['checked'] == true);
            if (checkedItems.length == 0) {
                return false;
            } else {
                return true;
            }
        }
    }

    @Watch('$_getGeofencesTypes')
    watchGeofencesTypes(val) {
        this.gfTypes = JSON.parse(JSON.stringify(val));
    }

    get getGeofenceType() {
        return JSON.parse(JSON.stringify(this.$_getGeofencesTypes));
    }

    showGeofenceFilters() {
        this.menu = true;
    }

    closeMenu() {
        // this.menu = false;
    }

    updateItemChecked(value, index){
        this.getGeofenceType[index]['checked'] = value;
        this.updateFilter();
    }

    updateFilter(): void {
        this.$_setGeofencesFilter(JSON.parse(JSON.stringify(this.getGeofenceType)));
    }

    @Emit()
    deleteEvent() {}

    @Emit()
    editEvent() {}

    @Emit()
    uploadFile() {
        return this.tab;
    }

    @Emit()
    addEvent() {}
}
